export const DEG2RAD = Math.PI / 180
export const RAD2DEG = 180 / Math.PI

export function clamp(value: number, min: number, max: number): number {
  return Math.max(min, Math.min(max, value))
}

/** n mod m, always in [0, m). */
export function euclideanModulo(n: number, m: number): number {
  return ((n % m) + m) % m
}

export function degToRad(degrees: number): number {
  return degrees * DEG2RAD
}

export function radToDeg(radians: number): number {
  return radians * RAD2DEG
}

export function lerp(x: number, y: number, t: number): number {
  return (1 - t) * x + t * y
}
